import { api } from "../api";

export async function renderPartners(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Partners</h1>
    <div class="card" style="max-width:560px;margin-bottom:16px">
      <h2 style="margin-top:0">Создать токен</h2>
      <form class="row" id="newf" style="flex-direction:column;align-items:stretch;gap:10px">
        <input name="name" placeholder="Название партнёра" required/>
        <label><span style="color:#7b8499">Стартовый баланс (USD):</span>
          <input name="initial_balance_usd" type="number" step="0.001" value="0"/></label>
        <label><span style="color:#7b8499">Owner user_id (опц.):</span>
          <input name="owner_user_id" type="number"/></label>
        <button>Создать</button>
      </form>
      <p id="newresult" style="color:#7b8499;margin-top:12px"></p>
    </div>
    <div id="list">Загрузка…</div>`;

  (el.querySelector<HTMLFormElement>("#newf"))!.addEventListener("submit", async e => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const fd = new FormData(form);
    const result = el.querySelector("#newresult")!;
    try {
      const r = await api.createPartner({
        name: fd.get("name"),
        initial_balance_usd: Number(fd.get("initial_balance_usd") || 0),
        owner_user_id: fd.get("owner_user_id") ? Number(fd.get("owner_user_id")) : undefined,
      });
      result.innerHTML = `
        ✅ Создан партнёр <b>${esc(r.name)}</b><br/>
        <span style="color:#ff6b6b">⚠️ Токен показан ОДИН РАЗ:</span><br/>
        <code style="font-size:11px;word-break:break-all;background:#1c2030;padding:6px;display:block;margin-top:6px;border-radius:4px">${r.token}</code>
      `;
      form.reset();
      await reload(el);
    } catch (err: any) { result.textContent = `❌ ${err.message}`; }
  });

  await reload(el);
}

async function reload(el: HTMLElement): Promise<void> {
  const { partners } = await api.partners();
  const list = el.querySelector("#list")!;
  if (!partners.length) {
    list.innerHTML = `<p class="empty">Партнёров пока нет.</p>`;
    return;
  }
  list.innerHTML = `
    <div class="table-wrap"><table>
      <thead><tr>
        <th>Name</th><th>Token suffix</th><th>Balance (USD)</th>
        <th>Spent (USD)</th><th>Active</th><th>Last used</th><th></th>
      </tr></thead>
      <tbody>${partners.map(p => `
        <tr data-token-suffix="${p.token_suffix}">
          <td><b>${esc(p.name)}</b></td>
          <td><code>…${p.token_suffix}</code></td>
          <td>
            <span class="bal">${formatUsd(p.balance_usd)}</span>
            <form class="row" data-topup="${p.token_suffix}" style="display:inline-flex;margin-left:6px">
              <input type="number" name="delta" step="0.001" placeholder="+/- USD" style="width:80px"/>
              <button>OK</button>
            </form>
          </td>
          <td>${formatUsd(p.total_spent_usd)}</td>
          <td>${p.is_active ? "✓" : "✗"}</td>
          <td>${(p.last_used_at || "—").toString().slice(0, 19).replace("T", " ")}</td>
          <td>
            <button data-stats="${p.token_suffix}" class="ghost">Stats</button>
            <button data-revoke="${p.token_suffix}" class="ghost">Revoke</button>
          </td>
        </tr>
        <tr class="stats-row" data-stats-row="${p.token_suffix}" hidden>
          <td colspan="7" style="background:#1c2030"><div class="stats-content">…</div></td>
        </tr>
      `).join("")}</tbody>
    </table></div>`;

  // Topup/revoke/stats нуждаются в полном токене — но мы храним только suffix.
  // По требованию безопасности: операции ведутся через suffix-prefix admin endpoint;
  // если не хочешь — сделай поиск по полному токену через ?token=… input.
  list.querySelectorAll<HTMLFormElement>("form[data-topup]").forEach(f => {
    f.addEventListener("submit", async e => {
      e.preventDefault();
      const suffix = f.dataset.topup!;
      const fullToken = await promptFullToken(suffix);
      if (!fullToken) return;
      const delta = Number(new FormData(f).get("delta"));
      if (!delta) return;
      try {
        const r = await api.topupPartner(fullToken, delta);
        const cell = f.parentElement!.querySelector<HTMLElement>(".bal")!;
        cell.textContent = formatUsd(r.balance_usd);
      } catch (err: any) { alert(err.message); }
    });
  });

  list.querySelectorAll<HTMLButtonElement>("button[data-revoke]").forEach(b => {
    b.addEventListener("click", async () => {
      const suffix = b.dataset.revoke!;
      const fullToken = await promptFullToken(suffix, "Введи полный токен партнёра для revoke:");
      if (!fullToken) return;
      if (!confirm("Точно ревокнуть?")) return;
      try {
        await api.revokePartner(fullToken);
        await reload(el);
      } catch (err: any) { alert(err.message); }
    });
  });

  list.querySelectorAll<HTMLButtonElement>("button[data-stats]").forEach(b => {
    b.addEventListener("click", async () => {
      const suffix = b.dataset.stats!;
      const fullToken = await promptFullToken(suffix, "Введи полный токен партнёра для stats:");
      if (!fullToken) return;
      const row = list.querySelector<HTMLElement>(`tr[data-stats-row="${suffix}"]`)!;
      row.hidden = !row.hidden;
      if (!row.hidden) {
        try {
          const s = await api.partnerStats(fullToken, 30);
          row.querySelector(".stats-content")!.innerHTML = `
            <p>Daily breakdown:</p>
            <table style="background:transparent;width:auto">
              <thead><tr><th>Date</th><th>Spent (USD)</th><th>Topup (USD)</th></tr></thead>
              <tbody>${(s.daily || []).map((d: any) => `
                <tr><td>${d.date}</td><td>${formatUsd(d.spent_usd)}</td><td>${formatUsd(d.topup_usd)}</td></tr>
              `).join("") || "<tr><td colspan='3'>нет данных</td></tr>"}</tbody>
            </table>`;
        } catch (e: any) {
          row.querySelector(".stats-content")!.textContent = `❌ ${e.message}`;
        }
      }
    });
  });
}

async function promptFullToken(suffix: string, msg = "Введи полный токен:"): Promise<string | null> {
  const full = prompt(`${msg}\n(suffix: …${suffix})`);
  if (!full) return null;
  if (!full.endsWith(suffix)) {
    alert("Suffix не совпадает");
    return null;
  }
  return full.trim();
}

function formatUsd(value: unknown): string {
  return "$" + Number(value || 0).toFixed(3);
}

function esc(s: any): string {
  return String(s ?? "").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]!));
}
